import { Divider, Flex, Skeleton } from '@chakra-ui/react';
import { Fragment } from 'react';

const MetricLoadingCell = () => {
  return (
    <>
      <Flex
        direction="column"
        align="flex-start"
        justify={'start'}
        minH="184px"
        borderLeft="1px solid #E0E0E0"
        p={3}
        bg="white"
      >
        <Flex align="center" mb={1}>
          <Skeleton w="8px" h="8px" borderRadius="full" mr={2} />
          <Skeleton w="60px" h="20px" />
        </Flex>
        <Skeleton w="100%" h="24px" mt={2} />
      </Flex>
      <Divider />
    </>
  );
};

export default MetricLoadingCell;
